import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seccion-catalogacion',
  templateUrl: './seccion-catalogacion.component.html',
  styleUrls: ['./seccion-catalogacion.component.css']
})
export class SeccionCatalogacionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
